module.exports = __webpack_public_path__ + "static/media/Coaxial cables.7060e598.png";